import { useCallback, useState } from "react";
import { useOpenProgressModal } from "../../../../../../../lib/hooks/useOpenProgressModal";
import { postAll } from "../../../../../../../acions/processing/batches";
import { useAppDispatch } from "../../../../../../../store";

export const usePostAll = (id: string, onSuccess: () => void) => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { openModal } = useOpenProgressModal(
    "Posting Draft Payments",
    "Posting some draft payments failed",
    onSuccess,
    {},
    onSuccess,
  );

  const onPostAll = useCallback(() => {
    setIsLoading(true);

    Promise.resolve(dispatch(postAll(id)))
      .then((res: any) => {
        openModal(res);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [dispatch, id, openModal]);

  return { isLoading, onPostAll };
};
